var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 5.60417V30.3958M4.375 14.2083C4.375 10.9417 4.375 9.30833 5.01083 8.06C5.57009 6.96244 6.46244 6.07009 7.56 5.51083C8.80833 4.875 10.4417 4.875 13.7083 4.875H21.2917C24.5583 4.875 26.1917 4.875 27.44 5.51083C28.5376 6.07009 29.4299 6.96244 29.9892 8.06C30.625 9.30833 30.625 10.9417 30.625 14.2083V21.7917C30.625 25.0583 30.625 26.6917 29.9892 27.94C29.4299 29.0376 28.5376 29.9299 27.44 30.4892C26.1917 31.125 24.5583 31.125 21.2917 31.125H13.7083C10.4417 31.125 8.80833 31.125 7.56 30.4892C6.46244 29.9299 5.57009 29.0376 5.01083 27.94C4.375 26.6917 4.375 25.0583 4.375 21.7917V14.2083Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.246fe42b4d73382d4896b10260930b84.svg";
export { ForwardRef as ReactComponent };